module.exports = __webpack_public_path__ + "img/preimush-img-4.755df34a.png";